import { getSupportImageTypes, toImagesBlob } from 'guardian-liveness-detection-lib/src/libs/toImages'

export async function resolveHandler(video: HTMLVideoElement): Promise<Blob[]> {
  const supportType = getSupportImageTypes()
  if (!supportType.includes('image/webp')) {
    return await (toImagesBlob(video, { type: 'image/jpeg' }))
  }
  return await (toImagesBlob(video, { type: 'image/webp' }))
}
